import { HelpOutline } from '@mui/icons-material';
import { IconButton, IconButtonOwnProps } from '@mui/material';

const DOCS_PREFIX = 'https://neurostuff.github.io/compose-docs/';

const ToDocsIcon = ({  url, ...props  }: IconButtonOwnProps & { url: string }) => {
    return (
        <IconButton
            {...props}
            size="small"
            target="_blank"
            href={`${DOCS_PREFIX}${url}`}
            onClick={(e) => e.stopPropagation()}
        >
            <HelpOutline sx={{ height: '0.8em', width: '0.8em' }} />
        </IconButton>
    );
};

export default ToDocsIcon;
